import * as jsPDF from 'jspdf';
import QRCode from 'qrcode'

export const printOneStockTicket = async (data, numberTickets) => {
    let doc = new jsPDF('l', 'mm', [420, 290]);

    await fillStockTicket(data, numberTickets, doc)

    doc.autoPrint();
    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 100);
}

export const printArrayStockTicket = async (arrayStock, numberTickets = 1) => {
    let doc = new jsPDF('l', 'mm', [420, 290]);

    let index = 0
    for (let data of arrayStock) {
        if (index !== 0) doc.addPage()
        await fillStockTicket(data, numberTickets, doc)
        index++;
    }

    doc.autoPrint();
    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 100);
}

const fillStockTicket = async (data, number, doc) => {
    await fillStockTicketAux(data, doc)

    for (let i = 0; i < number - 1; i++) {
        doc.addPage();
        await fillStockTicketAux(data, doc)
    }
}

const fillStockTicketAux = async (data, doc) => {
    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();

    const width1Column = width * 0.07
    const width2Column = width * 0.35

    let { reference, number, brand, model, color, quality, description } = data;

    //let img = document.createElement('img')
    //img.src = await QRCode.toDataURL("https://taskmanager-produccion.firebaseapp.com/stock/modify/"+reference)
    //doc.addImage(img, 'PNG', 0, height * 0.35, 65, 65, '', 'FAST');

    doc.setFontSize(55);
    doc.setFontType('bold');
    doc.text(`${reference || ""}`, width1Column, height * 0.19);

    doc.setFontSize(37);
    doc.setFontType('normal');
    doc.text(`${brand || ""} ${model || ""}`, width1Column, height * 0.35);

    doc.setFontSize(30);
    const line = `${description || ""} ${color || ""}`.slice(0, 55)
    doc.text(line, width1Column, height * 0.52, { maxWidth: width - 30 })

    doc.setFontSize(45);
    doc.setFontType('bold');
    doc.text(`${quality || ""}`, width1Column, height * 0.93);
}